import { useLocation } from '@reach/router'
import React, { memo, useRef, useState, useEffect } from 'react'

import { MobileButtonShoppingList } from './components/MobileButtonShoppingList'
import { MobileLateralMenu } from './components/MobileLateralMenu/Index'
import NotificationsBar from './components/NotificationsBar'
import FirstColumnHeader from './FirstColumnHeader'
import SecondColumnHeader from './SecondColumnHeader'
import { HAS_WINDOW } from '../../../constants'
import { useStoreContext } from '../../../contexts/StoreContext'
import { useHasActiveCoupons } from '../../../hooks/useHasActiveCoupons'
import useWindowDimensions from '../../../hooks/useWindowDimensions'
import SearchInput from '../SearchInput'
import './navbar.scss'

type Callback = () => unknown

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false)
  const [showMenu, setShowMenu] = useState(false)
  const { isMobile: isMobileHook } = useWindowDimensions()
  const [viewNumber, setViewNumber] = useState(0)
  const [position, setPosition] = useState<number | undefined>()
  const [subcategoriPosition, setSubcategoriPosition] = useState(0)
  const [indicators, setIndicators] = useState<string[]>([])
  const [currentCategorie, setCurrentCategorie] = useState('')
  const [currentSubCategorie, setCurrentSubCategorie] = useState('')
  const dismissTransition = useRef<Callback | undefined>()
  const { allCategories } = useStoreContext()
  const { couponsLoading, hasActiveCoupons } = useHasActiveCoupons()
  const location = useLocation()

  const hiddenRegionalizationInfos =
    location.pathname.includes('/restricao-alimentar') ||
    location.pathname.includes('/busca-multipla')

  function setBreadcrumb(title: string) {
    setIndicators([...indicators, title])
  }

  const CategorieViewProps = {
    setIndicators,
    indicators,
    setViewNumber,
    setBreadcrumb,
    setSubcategoriPosition,
  }

  const handleCloseSlideOver = () => {
    dismissTransition.current?.()
    setShowMenu(false)
  }

  useEffect(() => {
    if (isMobileHook !== null) {
      setIsMobile(isMobileHook)
    }
  }, [isMobileHook])

  useEffect(() => {
    if (!HAS_WINDOW) {
      return
    }

    if (showMenu) {
      document.getElementById('layout')?.classList.add('no-scroll')
    } else {
      document.getElementById('layout')?.classList.remove('no-scroll')
    }
  }, [showMenu])

  return (
    <header
      className={`navbar / grid-content-full ${
        hiddenRegionalizationInfos ? 'is-multiple-search' : ''
      }`}
      id="main-header"
      style={{ zIndex: 999 }}
    >
      <NotificationsBar />
      <div className="navbar__header">
        <section className="navbar__row">
          <FirstColumnHeader setShowMenu={setShowMenu} />
          {(!hiddenRegionalizationInfos ||
            (hiddenRegionalizationInfos && !isMobile)) && (
            <>
              <SearchInput
                placeholder={
                  isMobile
                    ? 'Pesquise por produtos ou marcas'
                    : 'Pesquise por um ou mais produtos ou marcas'
                }
              />
              <MobileButtonShoppingList />
            </>
          )}
          <SecondColumnHeader />
        </section>
      </div>
      {isMobile && (
        <MobileLateralMenu
          showMenu={showMenu}
          dismissTransition={dismissTransition}
          viewNumber={viewNumber}
          couponsLoading={couponsLoading}
          hasActiveCoupons={hasActiveCoupons}
          position={position}
          currentCategorie={currentCategorie}
          allCategories={allCategories}
          categorieViewProps={CategorieViewProps}
          currentSubCategorie={currentSubCategorie}
          subcategoriPosition={subcategoriPosition}
          handleSetViewNumber={setViewNumber}
          handleSetCurrentSubCategorie={setCurrentSubCategorie}
          handleSetCurrentItem={setCurrentCategorie}
          handleSetShowMenu={setShowMenu}
          handleOnDismiss={handleCloseSlideOver}
          handleCloseMenu={handleCloseSlideOver}
          handleSetPosition={setPosition}
          handleSetBreadcrumb={setBreadcrumb}
        />
      )}
    </header>
  )
}

export default memo(Navbar)
